"use client";

import React from "react";
export default function GlobalImpactInNumbers() {
  return;
}